module.exports = __webpack_public_path__ + "static/img/far3.d697b9e9.png";